import i18n from "../../i18n";

export function MustSellUOMTypes() {
    return Object.freeze({
        EACHES: { key: "eaches", value: i18n.t('common.eaches') },
        CASES: { key: "cases", value: i18n.t('common.cases') }
    })
}